export default {
  versions: (state) => state.versions,
  agencies: (state) => state.agencies,
  loading: (state) => state.loading,
  instanceId: (state) => state.instanceId,
  versionsPerAgentEvolutionStats: (state) => state.versionsPerAgentEvolutionStats,
  page: (state) => state.page,
  sortBy: (state) => state.sortBy,
  orderBy: (state) => state.orderBy,
  search: (state) => state.search,
  hasVersions: (state) => state.versions?.collection?.length > 0,
};
